/* More Similar Items: extend Shopify's related recommendations with products from a shared collection. */
(function(){
  'use strict';
  function extend(root){
    if(!root || root.dataset.seeratExtrasAdded==='yes')return;
    var grid=root.querySelector('.product-recommendations-placeholder .grid');
    if(!grid)return;
    var max=Math.max(2,Math.min(20,parseInt(root.dataset.limit,10)||6));
    var items=Array.from(grid.children).filter(function(n){return n.matches('.grid__item, .grid-product')});
    if(!items.length)return;
    var seen=new Set();
    function key(card){var a=card.querySelector('a[href*="/products/"]');return a?(a.getAttribute('href')||'').split('?')[0].replace(/\/$/,''):'';}
    items.forEach(function(item){var k=key(item);if(k)seen.add(k);});
    var tpl=root.querySelector('template[data-seerat-rec-extras]');
    if(tpl && items.length<max){
      Array.from(tpl.content.children).forEach(function(card){
        if(items.length>=max)return;
        var k=key(card);if(!k||seen.has(k))return;
        seen.add(k);grid.appendChild(card.cloneNode(true));items.push(card);
      });
    }
    root.dataset.seeratExtrasAdded='yes';
    if(window.theme && typeof window.theme.reinitProductGridItem==='function')window.theme.reinitProductGridItem(root);
  }
  document.addEventListener('recommendations:loaded',function(e){
    var root=e.detail&&e.detail.section;
    if(root && root.matches('product-recommendations.seerat-phase2-recommendations'))extend(root);
  });
})();
